import React, { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Button } from "../components/ui/button";
import { ArrowRight, Newspaper, Link as LinkIcon } from "lucide-react";
import PilotApplicationDialog from "../components/PilotApplicationDialog";
import { handleHashBasedNavigation } from "../utils/scrollUtils";
const Pilot: React.FC = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const handleOpenDialog = () => {
    setIsDialogOpen(true);
  };

  // Ensure hash navigation happens after component mount
  useEffect(() => {
    handleHashBasedNavigation();
  }, []);
  return <div className="flex flex-col min-h-screen">
      {/* Dialog for application form */}
      <PilotApplicationDialog open={isDialogOpen} onOpenChange={setIsDialogOpen} />

      {/* Hero Section */}
      <div className="bg-tagblue">
        <Navbar />
        <div className="container mx-auto px-4 py-16 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            TagMusic Pilot Program
          </h1>
          <p className="text-white text-lg max-w-2xl mx-auto mb-8">To test the AI Music Framework written by the members of Music Tech India, global solution providers in AI Music are jointly running a POC to test it in India</p>
          <Button className="bg-white text-tagblue hover:bg-gray-100 px-8 py-6 rounded-full" onClick={handleOpenDialog}>
            Join the Pilot Program
          </Button>
        </div>
      </div>

      {/* Pilot Program Overview */}
      <div className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold mb-10">Pilot Program Overview</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
            <div>
              <p className="text-gray-700 mb-6">The TagMusic Pilot Program aims to implement the AI Music Framework Blueprint, leveraging C2PA & CAWG specs. While all the modules covers various approaches, we will focus solely on implementing the overall Blueprint. The overall tech stack will be a C2PA + CAWG implementation, ensuring transparency and a robust system governing AI inclusion.</p>
              
              <ul className="space-y-4 text-gray-700">
                <li className="flex items-start">
                  <div className="mr-2 mt-1 bg-tagblue rounded-full p-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                  </div>
                  <span>Setting up the most ideal AI Inclusion scenarios</span>
                </li>
                <li className="flex items-start">
                  <div className="mr-2 mt-1 bg-tagblue rounded-full p-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                  </div>
                  <span>Reliable authentication & verification mechanisms</span>
                </li>
                <li className="flex items-start">
                  <div className="mr-2 mt-1 bg-tagblue rounded-full p-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                  </div>
                  <span>Interoperability for industry-wide standards including C2PA</span>
                </li>
                <li className="flex items-start">
                  <div className="mr-2 mt-1 bg-tagblue rounded-full p-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                  </div>
                  <span>A global testbed for transparent AI standards</span>
                </li>
                <li className="flex items-start">
                  <div className="mr-2 mt-1 bg-tagblue rounded-full p-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                  </div>
                  <span>Global Advisory Board to manage technology challenges with global jurisdiction & challenges</span>
                </li>
                <li className="flex items-start">
                  <div className="mr-2 mt-1 bg-tagblue rounded-full p-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                  </div>
                  <span>Creator & Label dashboard for transparent AI operations   </span>
                </li>
              </ul>
            </div>
            <div>
              <img src="/lovable-uploads/44e1e013-4aca-409f-89ac-c64750c70dd8.png" alt="AI Music Framework Ecosystem Overview" className="w-full h-auto" />
            </div>
          </div>
        </div>
      </div>

      {/* Operating Verticals */}
      <div className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12">Phase-wise execution with Partners</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center p-6">
              <div className="text-tagblue mb-4 flex justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 18V5l12-2v13" />
                  <circle cx="6" cy="18" r="3" />
                  <circle cx="18" cy="16" r="3" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-2">Phase 1</h3>
              <p className="text-gray-600">Tagging Human Generated Music industrywide and setting up Artist authentication systems</p>
            </div>
            
            <div className="text-center p-6">
              <div className="text-tagblue mb-4 flex justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect width="18" height="18" x="3" y="3" rx="2" />
                  <circle cx="9" cy="9" r="2" />
                  <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-2">Phase 2</h3>
              <p className="text-gray-600">Creating Voice IDs for Singers and enabling Ethical AI attribution & detection mechanisms</p>
            </div>
            
            <div className="text-center p-6">
              <div className="text-tagblue mb-4 flex justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
                  <polyline points="3.29 7 12 12 20.71 7" />
                  <line x1="12" x2="12" y1="22" y2="12" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-2">Phase 3</h3>
              <p className="text-gray-600">Testing integration with DSPs and PROs; enabling AI voice authentication module</p>
            </div>
          </div>
        </div>
      </div>

      {/* Stakeholder Benefits */}
      <div id="stakeholder-benefits" className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12">Stakeholder Benefits</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            <div className="p-6 border rounded-lg">
              <div className="text-tagblue mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 19c0-4.2-2.8-7-7-7H4v8h1a9.94 9.94 0 0 0 7 3Z" />
                  <path d="M12 19c0-4.2 2.8-7 7-7h1v8h-1a9.94 9.94 0 0 1-7 3Z" />
                  <path d="M12 19V5" />
                  <path d="M8 5h8" />
                  <path d="M8 9h8" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-4">Artists & Singers</h3>
              <ul className="space-y-2 text-gray-600">
                <li>• Join Voice ID & protect voice against AI cloning</li>
                <li>• Additional monetization on Voice AI opt-in</li>
                <li>• Revenue & attribution tracking</li>
              </ul>
              
              {/* In News Partition */}
              <div className="mt-6 pt-4 border-t border-gray-200">
                <div className="flex items-center mb-2 text-tagblue">
                  <Newspaper size={16} className="mr-2" />
                  <span className="font-medium">In News</span>
                </div>
                <a href="https://www.wipo.int/web/wipo-magazine/articles/ai-voice-cloning-how-a-bollywood-veteran-set-a-legal-precedent-73631" target="_blank" rel="noopener noreferrer" className="block hover:bg-gray-50 p-2 rounded-md transition-colors">
                  <div className="flex items-start">
                    <LinkIcon size={14} className="mt-1 mr-2 flex-shrink-0 text-gray-400" />
                    <div>
                      <p className="text-sm font-medium text-gray-800 hover:text-tagblue">BomHC protects Arijit Singh voice rights</p>
                      <p className="text-xs text-gray-500 mt-1">17 April 2025</p>
                    </div>
                  </div>
                </a>
              </div>
            </div>
            
            <div className="p-6 border rounded-lg">
              <div className="text-tagblue mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect width="18" height="18" x="3" y="3" rx="2" />
                  <circle cx="9" cy="9" r="2" />
                  <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-4">Labels & Publishers</h3>
              <ul className="space-y-2 text-gray-600">
                <li>• Reporting AI inclusion via detection mechanisms</li>
                <li>• Data privacy for provenance metadata</li>
                <li>• Protect sanctity of legacy human music</li>
              </ul>
              
              {/* In News Partition */}
              <div className="mt-6 pt-4 border-t border-gray-200">
                <div className="flex items-center mb-2 text-tagblue">
                  <Newspaper size={16} className="mr-2" />
                  <span className="font-medium">In News</span>
                </div>
                <a href="https://www.wipo.int/web/wipo-magazine/articles/royalties-in-the-age-of-ai-paying-artists-for-ai-generated-songs-73739" target="_blank" rel="noopener noreferrer" className="block hover:bg-gray-50 p-2 rounded-md transition-colors">
                  <div className="flex items-start">
                    <LinkIcon size={14} className="mt-1 mr-2 flex-shrink-0 text-gray-400" />
                    <div>
                      <p className="text-sm font-medium text-gray-800 hover:text-tagblue">Royalties in the age of AI - Protecting Rightsholders</p>
                      <p className="text-xs text-gray-500 mt-1">6 May 2025</p>
                    </div>
                  </div>
                </a>
              </div>
            </div>
            
            <div className="p-6 border rounded-lg">
              <div className="text-tagblue mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M3 3v18h18" />
                  <path d="m19 9-5 5-4-4-3 3" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-4">DSPs</h3>
              <ul className="space-y-2 text-gray-600">
                <li>• AI verification & provenance</li>
                <li>• User trust & Quality Assurance</li>
                <li>• Compliance with upcoming EU AI act & California's Transparency requirements</li>
              </ul>
              
              {/* In News Partition */}
              <div className="mt-6 pt-4 border-t border-gray-200">
                <div className="flex items-center mb-2 text-tagblue">
                  <Newspaper size={16} className="mr-2" />
                  <span className="font-medium">In News</span>
                </div>
                <a href="https://newsroom-deezer.com/2025/04/deezer-reveals-18-of-all-new-music-uploaded-to-streaming-is-fully-ai-generated/" target="_blank" rel="noopener noreferrer" className="block hover:bg-gray-50 p-2 rounded-md transition-colors">
                  <div className="flex items-start">
                    <LinkIcon size={14} className="mt-1 mr-2 flex-shrink-0 text-gray-400" />
                    <div>
                      <p className="text-sm font-medium text-gray-800 hover:text-tagblue">18% of all uploads fully AI generated : Deezer</p>
                      <p className="text-xs text-gray-500 mt-1">16 Apr 2025</p>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="p-6 border rounded-lg">
              <div className="text-tagblue mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 18V5l12-2v13" />
                  <circle cx="6" cy="18" r="3" />
                  <circle cx="18" cy="16" r="3" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-4">Distributors</h3>
              <ul className="space-y-2 text-gray-600">
                <li>• AI vs Human detection</li>
                <li>• Centralized AI metadata</li>
                <li>• Analytics</li>
              </ul>
              
              {/* In News Partition */}
              <div className="mt-6 pt-4 border-t border-gray-200">
                <div className="flex items-center mb-2 text-tagblue">
                  <Newspaper size={16} className="mr-2" />
                  <span className="font-medium">In News</span>
                </div>
                <a href="https://variety.com/2024/music/news/universal-music-believe-lawsuit-piracy-fake-artists-1236200612/" target="_blank" rel="noopener noreferrer" className="block hover:bg-gray-50 p-2 rounded-md transition-colors">
                  <div className="flex items-start">
                    <LinkIcon size={14} className="mt-1 mr-2 flex-shrink-0 text-gray-400" />
                    <div>
                      <p className="text-sm font-medium text-gray-800 hover:text-tagblue">UMG sues Believe over piracy and fake artists</p>
                      <p className="text-xs text-gray-500 mt-1">4 Nov 2024</p>
                    </div>
                  </div>
                </a>
              </div>
            </div>
            
            <div className="p-6 border rounded-lg">
              <div className="text-tagblue mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="m21.44 11.05-9.19 9.19a6 6 0 0 1-8.49-8.49l8.57-8.57A4 4 0 1 1 18 8.84l-8.59 8.57a2 2 0 0 1-2.83-2.83l8.49-8.48" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-4">AI Music Companies</h3>
              <ul className="space-y-2 text-gray-600">
                <li>• Ethical AI attribution & Special status for outputs</li>
                <li>• AI assisted copyright compliance</li>
                <li>• Market access</li>
              </ul>
              
              {/* In News Partition */}
              <div className="mt-6 pt-4 border-t border-gray-200">
                <div className="flex items-center mb-2 text-tagblue">
                  <Newspaper size={16} className="mr-2" />
                  <span className="font-medium">In News</span>
                </div>
                <a href="https://www.bbc.com/news/articles/cly3ld9wy3eo" target="_blank" rel="noopener noreferrer" className="block hover:bg-gray-50 p-2 rounded-md transition-colors">
                  <div className="flex items-start">
                    <LinkIcon size={14} className="mt-1 mr-2 flex-shrink-0 text-gray-400" />
                    <div>
                      <p className="text-sm font-medium text-gray-800 hover:text-tagblue">$10 Million streaming scam using AI</p>
                      <p className="text-xs text-gray-500 mt-1">6 Sep 2024</p>
                    </div>
                  </div>
                </a>
              </div>
            </div>
            
            <div className="p-6 border rounded-lg">
              <div className="text-tagblue mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                  <circle cx="9" cy="7" r="4" />
                  <path d="M22 21v-2a4 4 0 0 1 0 7.75" />
                  <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-4">PROs & other stakeholders</h3>
              <ul className="space-y-2 text-gray-600">
                <li>• Transparency & AI metadata access</li>
                <li>• Protect author's interests in AI deals</li>
                <li>• Enable additional renumeration through licensing</li>
              </ul>
              
              {/* In News Partition */}
              <div className="mt-6 pt-4 border-t border-gray-200">
                <div className="flex items-center mb-2 text-tagblue">
                  <Newspaper size={16} className="mr-2" />
                  <span className="font-medium">In News</span>
                </div>
                <a href="https://www.cisac.org/Newsroom/news-releases/cisacs-2025-annual-report-spotlights-ai-advocacy-anti-fraud-frameworks-and" target="_blank" rel="noopener noreferrer" className="block hover:bg-gray-50 p-2 rounded-md transition-colors">
                  <div className="flex items-start">
                    <LinkIcon size={14} className="mt-1 mr-2 flex-shrink-0 text-gray-400" />
                    <div>
                      <p className="text-sm font-medium text-gray-800 hover:text-tagblue">$8.5 billion is at risk for AV & Music creators by 2028 due to AI : CISAC</p>
                      <p className="text-xs text-gray-500 mt-1">22 May 2025</p>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Global Advisory & Observatory Board */}
      <div className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-8">Global Advisory Board</h2>
          
          <div className="max-w-3xl mx-auto">
            <div className="bg-gray-50 p-8 rounded-lg">
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                We are excited to announce the formation of our Global Advisory Board, 
                comprised of leading experts in the field of AI and music. These Global 
                Experts will provide invaluable guidance and strategic direction as we 
                implement our Pilot-PoC.
              </p>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                The board will bring together diverse perspectives from across the music 
                industry, technology sector, legal domain, and academia to ensure our 
                framework addresses the complex challenges at the intersection of AI and music.
              </p>
              <p className="text-lg text-tagblue font-medium">
                We are currently extending invitations to select experts who can contribute 
                to shaping the future of ethical AI in music. If you're interested in joining 
                our advisory board, please reach out through the application form.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="py-16 bg-tagblue text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-4">Be Part of the Future</h2>
          <p className="max-w-2xl mx-auto mb-8">
            Join the TagMusic Pilot Program and help shape the future of AI in Music industry
          </p>
          <Button className="bg-white text-tagblue hover:bg-gray-100 px-8 py-6 rounded-full" onClick={handleOpenDialog}>
            Join Now <ArrowRight className="ml-2 h-5 w-5" />
          </Button>
        </div>
      </div>

      <Footer />
    </div>;
};
export default Pilot;